import React, { useEffect, useState } from 'react';

// === Assets === //
import VideoIcon from '@assets/svg/film-outline.svg';

// === Components === //
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import VideoButton from '@components/common/VideoButton/VideoButton';

// === Helpers === //
import cn from 'classnames';
import { videoObject } from '@helpers/schemaOrg';

// === Styles === //
import * as styles from '@components/common/Video/Video.module.scss';

// === Types === //
import { IVideo } from '@components/common/Video/Video.d';

const Video = ({
  url,
  ratio = '16x9',
  poster,
  playButtonOff,
  playOnHover,
  background,
  icon = false,
  schemaData,
}: IVideo) => {
  const [videoType, setVideoType] = useState<'file' | 'youtube' | 'vimeo' | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (url.includes('youtu')) {
      setVideoType('youtube');
    } else if (url.includes('vimeo')) {
      setVideoType('vimeo');
    } else {
      setVideoType('file');
    }
  }, []);

  const onEnter = () => {
    setIsPlaying(true);
  };

  const onLeave = () => {
    setIsPlaying(false);
  };

  return (
    <>
      {schemaData && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(
              videoObject(
                url,
                poster,
                schemaData.name,
                schemaData.description,
                schemaData.uploadDate,
                schemaData.duration
              )
            )}
          </script>
        </Helmet>
      )}
      <div
        className={cn(styles['videoWrapper'])}
        onMouseEnter={playOnHover ? onEnter : () => {}}
        onMouseLeave={playOnHover ? onLeave : () => {}}
      >
        <div
          className={cn(
            styles['videoInner'],
            styles[`videoInnerRatio__${ratio}`],
            background && background === 'white' && styles['videoInnerWhite'],
            background && background === 'gray' && styles['videoInnerGray']
          )}
        >
          {/* {isPlaying && ( */}
          <ReactPlayer
            url={url}
            width="100%"
            height="100%"
            className="react-player"
            config={{
              youtube: {
                playerVars: {
                  showinfo: 0,
                  controls: playOnHover ? 0 : 1,
                  listType: 'user_uploads',
                  modestbranding: 1,
                },
              },
              vimeo: {
                playerOptions: {
                  controls: playOnHover ? false : true,
                  portrait: false,
                  title: false,
                  transparent: false,
                },
              },
              file: {
                attributes: {
                  controls: playOnHover ? false : true,
                },
              },
            }}
            playsinline={true}
            playing={isPlaying}
            muted={playOnHover ? true : false}
            onPlay={() => setIsPlaying(true)}
          />
          {/* )} */}

          {!playButtonOff && <VideoButton {...{ isPlaying, setIsPlaying }} />}
          {icon && (
            <div className={cn(styles.icon, isPlaying && styles.iconHide)}>
              <img src={VideoIcon} alt="" width="24px" height="24px" loading="lazy" />
            </div>
          )}

          {poster && poster !== '' && (
            <div
              className={cn(styles['videoPoster'], styles[isPlaying ? 'videoPosterHide' : ''])}
              style={{ backgroundImage: `url(${poster})` }}
            ></div>
          )}
        </div>
      </div>
    </>
  );
};

export default Video;
